import { Graphics } from "@pixi/graphics";
import { Text, TextStyle } from "@pixi/text";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "scene-manager";
import { BaseView } from "scene-manager";
import { Timer } from "../../game/views/tools/Timer";
import { getDefaultFontFamily } from "../../common/TextUtils";
import { IDestroyOptions } from "@pixi/display";

export class AdView extends BaseView<boolean> {
    private root: Graphics;
    private timerCountdown: number = 3;
    private countdownText: Text;
    
    public constructor(
        private readonly canvasScaler: ICanvasScaler,
        operationControls: PromiseCompletionSource<boolean>
    ) {
        super(operationControls);
        this.eventMode = "static";
        this.build();
        this.layout();
    }

    private build(): void {
        const { width, height } = this.canvasScaler.getSize();
        this.root = new Graphics();
        this.root.beginFill("#000000", 1);
        this.root.drawRect(0, 0, width, height);
        this.root.endFill();
        this.addChild(this.root);
        this.root.width = this.canvasScaler.browserWidth / (width / this.canvasScaler.referenceWidth);
        this.root.height = this.canvasScaler.browserHeight / (height / this.canvasScaler.referenceHeight);
        this.countdownText = this.addChild(new Text(`AD SHOWING  ${this.timerCountdown}`, this.countdownTextStyle));
        this.countdownText.anchor.set(0.5);
    }

    private layout(): void {
        this.root.position.set((this.canvasScaler.referenceWidth - this.root.width) * 0.5, (this.canvasScaler.referenceHeight - this.root.height) * 0.5);
        this.countdownText.position.set(this.canvasScaler.referenceWidth * 0.5, this.canvasScaler.referenceHeight * 0.5);
    }

    public override async start(): Promise<void> {
        await this.countdown();
    }

    private async countdown(): Promise<void> {
        while (this.timerCountdown > 0) {
            await this.sleep();
            this.timerCountdown--;
            this.countdownText.text = `AD SHOWING  ${this.timerCountdown}`;
        }
        this.operationControls.complete(true);
    }

    private sleep(): Timer {
        return new Timer(1000);
    }

    private get countdownTextStyle(): TextStyle {
        return new TextStyle({
            fontFamily: getDefaultFontFamily(),
            align: "center",
            fill: "#ffffff",
            fontSize: 60
        });
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        super.destroy(options);
    }
}